import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars
import UserLoginPropType from './userLogin';

const { arrayOf, bool, number, oneOfType, shape, string } = PropTypes;

export default shape({
  appCredentials: oneOfType([string, shape({})]),
  appName: string,
  appState: oneOfType([string, shape({})]),
  appVersion: oneOfType([number, string]),
  createdBy: string,
  createdDate: string,
  email: string,
  experience: string,
  fullName: string,
  includeCalendarAttachmentsOnEmails: bool,
  isArchived: bool,
  isGroup: bool,
  isIntegration: bool,
  isRestricted: bool,
  isShared: bool,
  isTeamAdmin: bool,
  isTeamOwner: bool,
  isSudoer: bool,
  lastLogin: UserLoginPropType,
  isLockedOut: bool,
  members: arrayOf(string),
  notificationPreference: shape({
    assignment: oneOfType([string, bool]),
    dailySummary: oneOfType([
      bool,
      string,
      shape({
        email: bool
      })
    ]),
    email: shape({
      enabled: bool.isRequired
    }).isRequired,
    reminders: oneOfType([string, bool]),
    runCompletion: oneOfType([string, bool]),
    sms: shape({
      enabled: bool.isRequired
    }),
    updates: oneOfType([string, bool]),
    weeklyTeamOwner: oneOfType([
      bool,
      string,
      shape({
        email: bool
      })
    ])
  }),
  phone: string,
  slackUsername: string,
  teamName: string,
  token: string,
  userID: string,
  userKey: string,
  username: string,
  userThumbnail: string
});



// WEBPACK FOOTER //
// ./js/types/api/user.js